import React, { useState } from 'react';

import { Popover } from '@mui/material';
import constants from 'constants/constants';
import moment from 'moment-timezone';
import { NavLink, useHistory } from 'react-router-dom';
import { token as tokenStorage } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';
import colorsVars from 'styles/colors.module.scss';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';
import { extractIpFromString } from 'utilitys/helpers/general';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useMobileStore } from 'store/mobile.store';

import { useMutationLogout } from 'api/mutations/logout.mutation';
import { useQueryApiVersion } from 'api/queries/apiVersion.query';

import Icon from 'components/common/Icons/base/Icon/Icon';

import MainUserImg from 'components/App/AuthenticateLayout/Header/MainUserImg/mainUserImg';
import { DarkMode } from 'components/App/AuthenticateLayout/Header/UserMenu/DarkMode/darkMode';
import classes from 'components/App/AuthenticateLayout/Header/UserMenu/userMenu.module.scss';

const { headerIconColor, headerPopoverIcon } = colorsVars;

const UserMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { mutate } = useMutationLogout();
    const { firstName, lastLogin, email } = useUserHook();
    const menuOpenRef = React.useRef(null);
    const { handleSnackBar } = useCustomSnackBar();
    const apiVersion = useQueryApiVersion();
    const history = useHistory();
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    const isMobile = useMobileStore((state) => state.isMobile);

    const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

    const logout = () => {
        const token = tokenStorage.get();
        if (token && email) {
            mutate(
                {
                    token,
                    username: email,
                },
                {
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                    onSettled: () => {
                        history.push('/logout');
                    },
                },
            );
        }
    };

    return (
        <div ref={menuOpenRef} onClick={toggleMenu}>
            {!menuOpen ? (
                <Icon
                    data-testid={'header-arrow-down'}
                    name={'header-arrow-down'}
                    className={classes.toggleIcon}
                    size={isMobile ? '' : '2rem'}
                    color={headerIconColor}
                />
            ) : (
                <Icon
                    name={'header-arrow-top'}
                    className={classes.toggleIcon}
                    size={isMobile ? '' : '2rem'}
                    color={headerIconColor}
                />
            )}

            <Popover
                anchorEl={menuOpenRef.current}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={menuOpen}
                className={classes.popover}
            >
                <div className={classes.userMenuItems}>
                    <div className={classes.userDetails}>
                        <span className={classes.greeting}>Hello {firstName},</span>
                        <MainUserImg />
                    </div>

                    <div className={classes.lastViewed}>{`Last login ${moment(lastLogin).format(
                        constants.formats.date.defaultWithTime,
                    )}`}</div>

                    <hr className={classes.breakLine} />

                    <DarkMode />
                    {!isMobile && (
                        <NavLink
                            className={classes.itemWrapper}
                            to={AppRoutes.buildPath(AppRoutes.SETTINGS)}
                            key={`Edit User Profile`}
                            id={'userMenu_item_userProfile'}
                        >
                            <div className={classes.item}>
                                <Icon name={'edit-user-profile'} size={'2.4rem'} color={headerPopoverIcon} />
                                <label>Edit User Profile</label>
                            </div>
                        </NavLink>
                    )}
                    <div className={classes.itemWrapper} onClick={logout}>
                        <div className={classes.item} id={'userMenu_item_logout'}>
                            <Icon name={'log-out'} size={'2.4rem'} color={headerPopoverIcon} />
                            <label>Logout</label>
                        </div>
                    </div>
                    <hr className={classes.breakLine} />

                    <div className={classes.appVersion}>
                        FE Version: {`${require('../../../../../../package.json').version}`}
                    </div>
                    <div className={classes.appVersion}>API Version: {apiVersion.data?.version}</div>

                    {isDev && (
                        <div className={classes.appVersion}>
                            API Server: {extractIpFromString(network.defaults.baseURL)}
                        </div>
                    )}
                </div>
            </Popover>
        </div>
    );
};

export default UserMenu;
